import { render, staticRenderFns } from "./ReportBuilding.vue?vue&type=template&id=3cf2edd4"
import script from "./ReportBuilding.vue?vue&type=script&lang=js"
export * from "./ReportBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports